import { render } from "./about-company.vue?vue&type=template&id=40fdc020"
import script from "./about-company.vue?vue&type=script&lang=js"
export * from "./about-company.vue?vue&type=script&lang=js"

import "./about-company.vue?vue&type=style&index=0&id=40fdc020&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__